<i18n>
{
  "en": {
    "revpash": "RevPash"
  },
  "es": {
    "revpash": "RevPash"
  }
}
</i18n>

<script>
import Component from 'vue-class-component';
import { MapActions } from '@core/helpers/decorators';
import * as KPITypes from '../constants';
import KpiComponent from './KpiComponent.vue';

@Component
@MapActions(['calculateRevPashKpi'])
export default class RevPashKpi extends KpiComponent {
  icon = 'mdi-table-chair'

  iconSize = 21;

  kpiType = KPITypes.REV_PASH

  isCurrencyUnit = true

  get title() {
    return this.$t('revpash');
  }

  async calculate() {
    await this.calculateRevPashKpi({ pointOfSaleGuid: this.$route.params.pointOfSaleGuid, isManaged: this.isManaged });
    this.loadKPIModel();
  }
}
</script>
